import React, { ReactElement } from 'react'
import sortBy from 'lodash/sortBy'
import OrganizationInvoiceElement from 'components/Organization/OrganizationBilling/OrganizationInvoiceElement'
import { OrganizationInvoice } from 'store/api/billing/payments.interface'
import NoResults from 'components/Dashboard/CommonComponents/NoResults'
import { Table, TableBody, TableHeader } from 'ui/Table'
import useBreakpointIndex from 'ui/Theme/useBreakpointIndex'
import TableAndAccordionContainer from 'ui/TableAndAccordionContainer'

const tableHeaders = [
  'Date',
  'Transaction ID',
  'Payment Method',
  'Amount',
  'Status',
  '', // header for open receipt button icon column
]

interface OrganizationInvoiceTableProps {
  paymentDataArray: Array<OrganizationInvoice> | undefined
}

export default function OrganizationInvoicesTable({
  paymentDataArray,
}: OrganizationInvoiceTableProps): ReactElement {
  const sortedData = sortBy(paymentDataArray, ['ts']).reverse()
  const isMobileOrTablet = useBreakpointIndex() < 2

  return (
    <>
      {!sortedData?.length ? (
        <NoResults message="No Invoices!" />
      ) : (
        <TableAndAccordionContainer dataTestId="invoices-table">
          {isMobileOrTablet ? (
            sortedData?.map(invoice => (
              <OrganizationInvoiceElement
                key={`${invoice.tx_id}-desktop`}
                invoice={invoice}
                tableHeaders={tableHeaders}
              />
            ))
          ) : (
            <Table>
              <TableHeader
                names={tableHeaders}
                sx={{
                  ':nth-of-type(3)': { pl: '1.2rem' },
                  ':last-of-type': { flex: '0 1 2.4rem' },
                }}
              />
              <TableBody>
                {sortedData?.map(invoice => (
                  <OrganizationInvoiceElement
                    key={`${invoice.tx_id}-desktop`}
                    invoice={invoice}
                    tableHeaders={tableHeaders}
                  />
                ))}
              </TableBody>
            </Table>
          )}
        </TableAndAccordionContainer>
      )}
    </>
  )
}
